import Loading from "components/Loading"
import RelatoryLoad from "components/RelatoryLoad"
import ModalContas from "./components/ModalContas";
import { useState } from "react";

const { SRelatoryItem } = require("./style")


const RelatoryItem = ({name, key_index, relatorio, relatorio_2, handleViewPdf, ranking, name_1, name_2, day_value, month_value, relatory_loaded}) => {

    const [modal, setModal] = useState(false);

    const getMedal = (i) => {
        if(i===0) return "ouro";
        if(i===1) return "prata";
        if(i===2) return "bronze";
    }

    return (    
        <SRelatoryItem>
            {
                modal ? <ModalContas close={() => setModal(false)} relatorio={relatorio} relatorio_2={relatorio_2}/> : null
            }
            {
                ranking && key_index <=2 ?
                    <img src={`/${getMedal(key_index)}.png`} />
                : null
            }
            <div className="relatory-item-content">
                <div>
                    <h3>{name}</h3>
                    {
                        relatorio ?  <i className="fa-solid fa-file-invoice-dollar icon-pdf" onClick={() => setModal(true)}/> : ""
                    }
                </div>
                <div className="row">
                    {
                        <>
                            <div className="col-6">
                                <p><span>{name_1}:</span></p>
                                <p>{day_value}</p>
                            </div>
                            <div className="col-6">
                                <p><span>{name_2}:</span></p>
                                <p>{month_value}</p>
                            </div>
                        </>
                    }
                    
                </div>
            </div>
        </SRelatoryItem>
    )
}

export default RelatoryItem